export default "__VITE_ASSET__DctOFrb0__"